import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/mobius/aduience.webp";

function Audiencemobius() {
  return (
    <section
      className="audience_mobius"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-md-6"
          >
            <h2 style={{ color: "#000" }}>
              <span style={{ color: "#214092" }}>Target </span>
              Audience
            </h2>
            <p>
              The mobile applications created by Mobius Risk Group mainly target
              their clientele in the United States.
            </p>
            <p>
              As the firm functions in the USA market, it was critical to modify
              the apps to meet the unique requirements and choices of their
              American clients.
            </p>
            <p>
              By concentrating on the USA market, Mobius Risk Group intends to
              improve their service delivery and accommodate the specific needs
              of their target audience.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Audiencemobius;
